/**
 * @flow
 * @relayHash 99bc468934310cbaf68570d2da961eef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobAssociatedFileInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeleteJobAssociatedFileMutationVariables = {|
  input: DeleteJobAssociatedFileInput
|};
export type DeleteJobAssociatedFileMutationResponse = {|
  +deleteJobAssociatedFile: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteJobAssociatedFileMutation = {|
  variables: DeleteJobAssociatedFileMutationVariables,
  response: DeleteJobAssociatedFileMutationResponse,
|};
*/


/*
mutation DeleteJobAssociatedFileMutation(
  $input: DeleteJobAssociatedFileInput!
) {
  deleteJobAssociatedFile(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteJobAssociatedFileInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteJobAssociatedFile",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobAssociatedFilePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteJobAssociatedFileMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteJobAssociatedFileMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteJobAssociatedFileMutation",
    "id": null,
    "text": "mutation DeleteJobAssociatedFileMutation(\n  $input: DeleteJobAssociatedFileInput!\n) {\n  deleteJobAssociatedFile(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0abb2f020275f99e0de28977121c427f';
module.exports = node;
